import TabNavigator from './TabNavigator'

export default TabNavigator
